import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'localeModal.header',
    defaultMessage: 'Select Your Language',
  },
});
